module.exports = __webpack_public_path__ + "img/cdn.c37ddf2.webp";